module.exports = __webpack_public_path__ + "static/media/deer-logo.b55379b3.svg";